module.exports = __webpack_public_path__ + "static/shield-7e4b8b430ad80bfeb8b90012dc646578.svg";